/**
 * 宠物篮球：规则事件 → 动作段（B，pet_arcade/core；合同 PET-ARCADE-BASKET-RULES-B-2026-10-01.md §3a，
 * 段名与状态对 I 的动作清单 F0 docs/coordination/MOTION-MANIFEST-F0-I-2026-10-01.md 修订 06:24:04 的 B1–B3）。纯函数，UI 播放器与用例共用一张表。
 *
 * 口径：规则在事件那一步判定，播放器在那一帧切段。段播完自动接哪一段（charge_start→charge_loop、land→wait_idle、recover→hold_idle）、
 * 起点状态对不上时挂起（B7）、压哨时先播完 react 再进 end（B6），都是播放器的事；这里只给「这条规则事件切到哪一段」。
 */

import type { BasketEventBody, BasketStance } from "./basket";

export type BasketClip = "hold_idle" | "charge_start" | "charge_loop" | "shoot" | "land" | "wait_idle" | "react_score" | "react_miss" | "recover" | "end";
export type BasketMotionState = "HOLD" | "CHARGE" | "AIR" | "WAIT" | "END";

const STATE: Record<BasketStance, BasketMotionState> = { holding: "HOLD", charging: "CHARGE", airborne: "AIR", waiting: "WAIT" };

/** 规则核心的姿态 → 动作状态（B1：一一对应）；局已结束时是 END。 */
export function basketMotionStateOf(stance: BasketStance, ended = false): BasketMotionState {
  return ended ? "END" : STATE[stance];
}

/** 一条规则事件要切到哪一段；null＝不切段（rim、buzzer 由 UI 叠表现；paused、resumed 冻结与恢复当前帧；主动退出直接离开）。带不带标识都收。 */
export function basketClipForEvent(event: BasketEventBody): BasketClip | null {
  switch (event.type) {
    case "started":
      return "hold_idle";
    case "charge_started":
      return "charge_start";
    case "shot":
      return "shoot";
    case "landed":
      return "land";
    case "scored":
      return "react_score";
    case "missed":
      return "react_miss";
    case "ball_returned":
      return "recover";
    case "ended":
      return event.reason === "quit" ? null : "end"; // 主动退出不播结尾段（I 定，与贪吃一致）
    default:
      return null;
  }
}
